import SwaggerUI from 'swagger-ui';
import "swagger-ui/dist/swagger-ui.css";
require("./template/_config/app.settings");

import slimscroll from "jquery-slimscroll";
import SmoothScroll from 'smooth-scroll';

window.myapp_config = require("./template/_config/app.config.js");
window.myapp_get_color = require("./template/_get/app.get.colors.js");
window.initApp = require("./template/_modules/app.init.js");

require("./template/_modules/app.domReady.js");
require("./template/_modules/app.orientationchange.js");
require("./template/_modules/app.resize.trigger.js");
require("./template/_modules/app.scroll.trigger.js");
require("./template/_modules/app.window.load.js");
require("./template/_modules/app.navigation.js");

if(document.getElementById("home_api") != null) {
    SwaggerUI({
        dom_id: '#home_api',
        url: 'https://getorder.timc.biz/api/v1'
    })
}
